import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { createPortal } from 'react-dom';
import { Map } from 'immutable';
import DatePicker from 'react-datepicker';

import Popup from '../helpers/Popup';
import FetchingError from '../helpers/FetchingError';
import FormGroup from '../helpers/FormGroup';
import Button from '../helpers/Button';

const PushNextActionDatesPopupComponent = ({
  onUpdate,
  onClose,
  onChange,
  onDateChange,
  formData,
  isPopupFetching,
  isPopupFetchingError,
}) => {
  const header = 'Push Next Action Dates';
  const footer = (
    <>
      <Button key="addTag" className="btn-primary" onClick={onUpdate}>
        Update
      </Button>
      <Button key="close" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="pushNextActionDatesPopup" loading={isPopupFetching}>
      <p>Adjust the dates of any existing Next Actions for the selected companies:</p>
      <div className="row d-flex align-items-center">
        <FormGroup className="col-xs-7">
          <div className="checkbox-wrap">
            <input
              checked={formData.get('forward', false)}
              id="forwardCb"
              name="forward"
              onChange={onChange}
              type="checkbox"
              autoFocus
            />
            <label htmlFor="forwardCb">Push all next action dates forward</label>
          </div>
        </FormGroup>
        <FormGroup className="col-xs-5">
          <div className="input-group">
            <input
              className="form-control"
              disabled={!formData.get('forward', false)}
              name="forwardDays"
              onChange={onChange}
              type="number"
              value={formData.get('forwardDays', '')}
            />
            <span className="input-group-addon">days</span>
          </div>
        </FormGroup>
      </div>
      <div className="row d-flex align-items-center">
        <FormGroup className="col-xs-7">
          <div className="checkbox-wrap">
            <input
              checked={formData.get('backward', false)}
              id="backwardCb"
              name="backward"
              onChange={onChange}
              type="checkbox"
            />
            <label htmlFor="backwardCb">Push all next action dates backward</label>
          </div>
        </FormGroup>
        <FormGroup className="col-xs-5">
          <div className="input-group">
            <input
              className="form-control"
              disabled={!formData.get('backward', false)}
              name="backwardDays"
              onChange={onChange}
              type="number"
              value={formData.get('backwardDays', '')}
            />
            <span className="input-group-addon">days</span>
          </div>
        </FormGroup>
      </div>
      <div className="row d-flex align-items-center">
        <FormGroup className="col-xs-7">
          <div className="checkbox-wrap">
            <input
              checked={formData.get('following', false)}
              id="followingCb"
              name="following"
              onChange={onChange}
              type="checkbox"
            />
            <label htmlFor="followingCb">Set all next action dates to the following date</label>
          </div>
        </FormGroup>
        <FormGroup className="col-xs-5">
          <DatePicker
            className="form-control"
            dateFormat="MM/DD/YYYY"
            disabled={!formData.get('following', false)}
            dropdownMode="select"
            onChange={onDateChange}
            popperContainer={({ children }) => createPortal(children, document.body)}
            selected={formData.get('followingDate')}
            showMonthDropdown
            showYearDropdown
          />
        </FormGroup>
      </div>
      <FetchingError error={isPopupFetchingError} />
    </Popup>
  );
};

PushNextActionDatesPopupComponent.propTypes = {
  formData: PropTypes.instanceOf(Map).isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export const PushNextActionDatesPopup = memo(PushNextActionDatesPopupComponent);
